import { client } from '@/app/api';
import type { User } from '@/features/auth/types';

export const getUser = () =>
  client.get<User>('/internal/user').then(res => {
    const user = res.data;

    return { ...user, currency: user.currency ?? 'USD' };
  });
